export enum SecurityTaskType {
  /**
   * Task to update a cipher's password that was found to be at-risk by an administrator
   */
  UpdateAtRiskCredential = 0,
}
